import { SAVE_ORDER_TO_ACCOUNT_SHOWN } from '../cache';

export const getSaveOrderToAccountShownKey = (orderId: string) => {
	return `${SAVE_ORDER_TO_ACCOUNT_SHOWN}_${orderId}`;
};
